<div class="container-areas">
    <div class="container-areas__header">
        <div class="column top">
            <button (click)="back$.emit()" class="container-areas__header__back">
                <i class="pi pi-angle-left"></i>
            </button>
            <h1 class="container-areas__header__title">
                {{ isEditMode ? ('areas.edit-area' | translate) : ('areas.config-area' | translate) }}
            </h1>
        </div>
    </div>

    <div
        [hidden]="isLoadingTags"
        class="container-areas__content"
    >
        <form [formGroup]="form" class="form">
            <ng-container *ngIf="!isEditMode">
                <span class="form__label">
                    {{ 'areas.type-area' | translate }}
                </span>
                <span *ngIf="!area && form.touched" class="form__error-tip tk-c-red">
                    {{ 'areas.error-select-area-type' | translate }}
                </span>
                <div class="form__area-type-list">
                    <button
                        (click)="setAreaType(AreaTypeEnum.Circle)"
                        [ngClass]="{ 'is-selected': form.value.Tp === AreaTypeEnum.Circle }"
                        class="form__area-type-list__item"
                    >
                        <img src="/assets/img/shapes/circle-w.svg" class="gray" alt="circle">
                        <img src="/assets/img/shapes/circle.svg" class="white" alt="circle">
                        <span class="form__area-type-list__item__title">
                            {{ 'areas.circle' | translate }}
                        </span>
                    </button>
                    <button
                        (click)="setAreaType(AreaTypeEnum.Polygon)"
                        [ngClass]="{ 'is-selected': form.value.Tp === AreaTypeEnum.Polygon }"
                        class="form__area-type-list__item"
                    >
                        <img src="/assets/img/shapes/shape.svg" class="gray" alt="polygon">
                        <img src="/assets/img/shapes/shape-w.svg" class="white" alt="polygon">
                        <span class="form__area-type-list__item__title">
                            {{ 'areas.polygon' | translate }}
                        </span>
                    </button>
                    <button
                        (click)="setAreaType(AreaTypeEnum.Line)"
                        [ngClass]="{ 'is-selected': form.value.Tp === AreaTypeEnum.Line }"
                        class="form__area-type-list__item line"
                    >
                        <img src="/assets/img/shapes/line.svg" class="gray" alt="line">
                        <img src="/assets/img/shapes/line-w.svg" class="white" alt="line">
                        <span class="form__area-type-list__item__title">
                            {{ 'areas.line' | translate }}
                        </span>
                    </button>
                </div>
            </ng-container>

            <span class="form__label">
                {{ 'areas.area-name' | translate }}
            </span>
            <span *ngIf="isErrorVisible('Nm')" class="form__error-tip tk-c-red">
                {{ 'areas.enter-area-name' | translate }}
            </span>
            <input
                formControlName="Nm"
                class="name-of-area"
                type="text"
                [placeholder]="'areas.enter-area-name' | translate"
                pInputText
            />
    
            <span class="form__label">
                {{ 'areas.enter-groups' | translate }}
            </span>
            <p-multiSelect
                #multiSelectGroups
                [(ngModel)]="selectedGroups"
                [ngModelOptions]="{standalone: true}"
                [options]="groups"
                (onChange)="onChangeSelectedTagsValue($event)"
                (onFilter)="onFilterTags($event)"
                [defaultLabel]="'areas.search-group' | translate"
                optionLabel="L"
            >
                <ng-template let-value pTemplate="selectedItems">
                    {{ 'areas.search-group' | translate }}
                </ng-template>
                <ng-template pTemplate="footer">
                    <div class="add-new-group">
                        <p-button (click)="addNewGroup()" class="add-new-group__btn" [label]="'areas.add-new-group' | translate"></p-button>
                    </div>
                </ng-template>
            </p-multiSelect>
    
            <div class="chip-list">
                <div *ngFor="let item of selectedGroups; let index = index" class="chip">
                    <span class="chip__title">{{ item.L }}</span>
                    <button (click)="removeGroup(index)" class="chip__remove">
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </div>
    
            <div class="color-picker-wrapper">
                <span class="form__label">
                    {{ 'areas.select-color' | translate }}
                </span>
                <p-colorPicker 
                    [(ngModel)]="color"
                    [ngModelOptions]="{standalone: true}"
                ></p-colorPicker>
            </div>
    
            <p-button (click)="submit()" [disabled]="isSavingForm" class="form__submit" [label]="'areas.save-area' | translate"></p-button>
        </form>
    </div>
</div>
